import { observable, action, makeAutoObservable } from 'mobx';
import Language from '../models/Language';

class LanguageStore {
    constructor() {
        makeAutoObservable(this)
    }

    @observable languageData: Language = {
        contents: {},
        languages: [],
        currentLanguage: '',
        defaultLanguage: '',
    };

    @action updateLanguageData(data: Language) {
        this.languageData = data;
    }

    getLanguageData() {
        return this.languageData;
    }
}

export default new LanguageStore();